function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var SvgColorMapLight = function SvgColorMapLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11 0 0 1.24 234.2 264.93)",
    id: "CxT3u1mmmI79t1piMz4a9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(19,117,171)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(189,217,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -250 -245.54959 C -250 -248.00748 -247.76142 -250 -245 -250 L 250 -250 L 250 245.54959000000002 L 250 245.54959000000002 C 250 248.00748000000002 247.76142 250.00000000000003 245 250.00000000000003 L -250 250.00000000000003 z",
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColorMapLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/color_map_light.78df15a0.svg";
export { ForwardRef as ReactComponent };